import $ from "jquery";

(function ($) {
	var page = 1;
	var postsPerPage = 4;
	var loading = false;

	function loadMoreArticles() {
		if (!loading) {
			loading = true;

			$(".load-more-button").hide();
			$(".loading-spinner").show();

			var offset = (page - 1) * postsPerPage;

			if (page === 1) {
				// Skip the first post on page 1
				offset++;
			}

			$.ajax({
				url: load_more_articles.ajax_url,
				type: "post",
				data: {
					action: "load_more_articles",
					nonce: load_more_articles.nonce,
					page: page,
					offset: offset,
				},
				success: function (response) {
					$(".post-container").append(response);
					page++;
					loading = false;
					$(".loading-spinner").hide();
					$(".load-more-button").show();
				},
			});
		}
	}

	$(document).on("click", ".load-more-button", function (e) {
		e.preventDefault();
		loadMoreArticles();
	});
})(jQuery);
